import "./App.css";
import { useDispatch } from "react-redux";
import * as React from "react";
import { getCategory } from "./actions/category";
import { getLocation } from "./actions/locations";
import { getCompanyAsset } from "./actions/asset";
import { getRevaluedAsset } from "./actions/revaluate";
import { getDisposedAsset } from "./actions/disposal";
import { getIntangibleAssets } from "./actions/intangibleAssets";
import { Fragment, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login/login";
import secureLocalStorage from "react-secure-storage";
import ResetPassword from "./pages/Login/ResetPassword";
import { getAllUsers } from "./actions/user";
import NotFound from "./pages/Not Found/NotFound";
import ResetMyPassword from "./user page/ResetPassword";
import { getRightOfUseAsset } from "./actions/rightOfUseAsset";
import { getNewUnapprovedAsset } from "./actions/newAsset";
import InternetConnectionMonitor from "./pages/Internet Connection/InternetConnection";
import { allActiveAssets } from "./actions/activeAsset";
import { allExhaustedAssets } from "./actions/exhaustedAsset";
import { allLocationData } from "./actions/locationData";
import { allYearData } from "./actions/yearData";
import { updateUser } from "./actions/user";
import AllAssets from "./pages/All Assets/allAssets";
import TangibleReport from "./pages/Report/assetReport";
import Analytics from "./pages/Insight/Insight";
import IntangibleReport from "./pages/Intangible Report/intangibleReport";
import UserAccountPage from "./user page/UserAccountPage";
import RightOfUseReport from "./pages/right of use assets/rightOfUse";
import { HelmetProvider } from "react-helmet-async";
import Approval from "./pages/Approvals/Approval";
import { Toaster } from "react-hot-toast";
import AppLayout from "./ui/AppLayout";
import ProtectedRoute from "./ui/ProtectedRoute";
import { getColorMode } from "./actions/colorChange";
import SummaryReport from "./pages/Summary Report/SummaryReport";
import TimeZoneCheckerModal from "./TimeZoneCheck/TimeZone";

const App = () => {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const dispatch = useDispatch();
  useEffect(() => {
    if (user) {
      dispatch(getLocation());
      dispatch(getCategory());
      dispatch(getCompanyAsset());
      dispatch(getRevaluedAsset());
      dispatch(getDisposedAsset());
      dispatch(getIntangibleAssets());
      dispatch(getAllUsers());
      dispatch(getNewUnapprovedAsset());
      dispatch(getRightOfUseAsset());
      dispatch(allActiveAssets());
      dispatch(allExhaustedAssets());
      dispatch(allLocationData());
      dispatch(allYearData());
    }
  }, [dispatch, user]);
  useEffect(() => {
    dispatch(getColorMode());
  }, [dispatch]);
  let approve = false;
  if (
    user?.results?.assets === "Administrator" ||
    user?.results?.assets === "Approver"
  ) {
    approve = true;
  } else {
    approve = false;
  }
  React.useEffect(() => {
    if (user) {
      dispatch(
        updateUser(user?.results._id, {
          login: "yes",
          system: "assets register",
        })
      );
    }
  }, [dispatch, user]);
  const mode = "light";
  return (
    <HelmetProvider>
      <TimeZoneCheckerModal />
      <div className={`${mode === "dark" ? "darkMode" : "lightMode"}`}>
        <Fragment>
          <InternetConnectionMonitor />
          <Routes>
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/assets-register" element={<Analytics />} />
              <Route index element={<Analytics />} />

              <Route
                path="/assets-register/all-assets"
                element={<AllAssets />}
              />
              <Route
                path="/assets-register/tangible-report"
                element={<TangibleReport />}
              />

              <Route
                path="/assets-register/intangible-report"
                element={<IntangibleReport />}
              />
              <Route
                path="/assets-register/summary-report"
                element={<SummaryReport />}
              />
              <Route
                path="/assets-register/user-page"
                element={<UserAccountPage />}
              />
              <Route
                path="/assets-register/right-of-use-report"
                element={<RightOfUseReport />}
              />
              {approve && (
                <Route
                  path="/assets-register/approvals"
                  element={<Approval />}
                />
              )}
            </Route>
            <Route
              path="/assets-register/resetPassword"
              element={<ResetPassword />}
            />
            <Route
              path="/assets-register/resetMyPassword/:token"
              element={<ResetMyPassword />}
            />
            <Route path="/assets-register/login" element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Fragment>
      </div>

      <Toaster
        position="top-center"
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          error: {
            duration: 6000,
          },
          style: {
            fontSize: "14px",
            maxWidth: "500px",
            padding: "10px 20px",
            backgroundColor: "#555",
            color: "#fff",
          },
        }}
      />
    </HelmetProvider>
  );
};

export default App;
